import { accountCircle } from './icons/account-circle';
import { activityLog } from './icons/activity-log';
import { add } from './icons/add';
import { arrowLeft } from './icons/arrow-left';
import { arrowRight } from './icons/arrow-right';
import { arrowSortDown } from './icons/arrow-sort-down';
import { arrowSortUp } from './icons/arrow-sort-up';
import { arrowsSort } from './icons/arrows-sort';
import { authBackground } from './icons/auth-background';
import { authFullBackground } from './icons/auth-full-background';
import { branding } from './icons/branding';
import { campaigns } from './icons/campaigns';
import { check } from './icons/check';
import { close } from './icons/close';
import { dashboard } from './icons/dashboard';
import { deleteTemporary } from './icons/delete-temporary';
import { devices } from './icons/devices';
import { edit } from './icons/edit';
import { help } from './icons/help';
import { interactions } from './icons/interactions';
import { logo } from './icons/logo';
import { logout } from './icons/logout';
import { marker } from './icons/marker';
import { more } from './icons/more';
import { navigationArrow } from './icons/navigation-arrow';
import { notifications } from './icons/notifications';
import { reboot } from './icons/reboot';
import { search } from './icons/search';
import { settings } from './icons/settings';
import { tutorial } from './icons/tutorial';
import { visibility } from './icons/visibility';
import { warning } from './icons/warning';
import { upload } from './icons/upload';
import { info } from './icons/info';

export type Icons = {
  accountCircle: React.ReactNode;
  activityLog: React.ReactNode;
  add: React.ReactNode;
  arrowLeft: React.ReactNode;
  arrowRight: React.ReactNode;
  arrowSortDown: React.ReactNode;
  arrowSortUp: React.ReactNode;
  arrowsSort: React.ReactNode;
  authBackground: React.ReactNode;
  authFullBackground: React.ReactNode;
  branding: React.ReactNode;
  campaigns: React.ReactNode;
  check: React.ReactNode;
  close: React.ReactNode;
  dashboard: React.ReactNode;
  deleteTemporary: React.ReactNode;
  devices: React.ReactNode;
  edit: React.ReactNode;
  help: React.ReactNode;
  interactions: React.ReactNode;
  logo: React.ReactNode;
  logout: React.ReactNode;
  marker: React.ReactNode;
  more: React.ReactNode;
  navigationArrow: React.ReactNode;
  notifications: React.ReactNode;
  reboot: React.ReactNode;
  search: React.ReactNode;
  settings: React.ReactNode;
  tutorial: React.ReactNode;
  visibility: React.ReactNode;
  warning: React.ReactNode;
  upload: React.ReactNode;
  info: React.ReactNode;
};

export const icons: Icons = {
  accountCircle,
  activityLog,
  add,
  arrowLeft,
  arrowRight,
  arrowSortDown,
  arrowSortUp,
  arrowsSort,
  authBackground,
  authFullBackground,
  branding,
  campaigns,
  check,
  close,
  dashboard,
  deleteTemporary,
  devices,
  edit,
  help,
  interactions,
  logo,
  logout,
  marker,
  more,
  navigationArrow,
  notifications,
  reboot,
  search,
  settings,
  tutorial,
  visibility,
  warning,
  upload,
  info,
};
